<template>
  <b-container class="">
    <div>
      <b-link @click="showCategories = !showCategories">Kategorie</b-link>
      <b-row class="inline m-2"
             v-if="showCategories">
        <b-col class="col-12">
          <b-button v-for="(item, key) in charts"
                    :key="key"
                    pill
                    variant="outline-primary"
                    class="m-1"
                    @click=" category = key , getG() ">
            {{item.key}}
          </b-button>
        </b-col>
      </b-row>
    </div>
    <h1>{{catKey}} / {{timelines[time]}}</h1>
        <line-chart :options="optionsC" :chartData="graphmodelC"></line-chart>
    <b-row class="mt-4">
      <b-col class="col-9">
        <b-button pill
                  v-for="(item,key) in timelines"
                  :key="key"
                  class="m-1"
                  @click="time = key , getG()">
          {{item}}
        </b-button>
      </b-col>
      <b-col >
    <b-form-group class=" col-2">
      <b-form-radio v-model="cf" name="some-radios" value="MAX" @input="getG()">Maximum</b-form-radio>
      <b-form-radio v-model="cf" value="AVERAGE" @input="getG()">Mittel</b-form-radio>
      <b-form-checkbox v-model="showCapacity"  @input="getG()">Kapazität</b-form-checkbox>
    </b-form-group>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import {VserverGraph} from "@/store/models/vserver/vserver_graph";
  import {Vserver} from "@/store/models/vserver/vserver";
  import {ChartOptions} from "@/mixins/chart_options";
  import LineChart from "./line-chart";

  export default {
        name: "chart-controller-vserver",
    components: {LineChart},
    data:()=>({
      liveLabel:[],
      timer:null,
      showCapacity:false,
      showCategories:true,
      showTimeLine:false,
      time:'',
      cf:'AVERAGE',
      category:'mem',
      charts:{
        mem:{
          key:'RAM',
        },
        cpu:{
          key:'CPU',
        },
        diskwrite:{
          key:'Schreiben',
        }
        /*FREEMEM:{
          key:'freemem',
        },
        LESEN:{
          key:'diskread',
        },*/

      },
        timelines:{
          live:'Live',
          hour:'Stunde',
          day:'Tag',
          week:'Woche',
          month:'Monat',
          year:'Jahr'
        },
      backgroundColor: {
        freemem:[
          'rgba(75, 192, 192, 0.2)',
        ],
        diskread:[
          'rgba(75, 192, 192, 0.2)',
          'rgba(153, 102, 255, 0.2)',
          'rgba(255, 159, 64, 0.2)'
        ],
        cpu:[
          'rgba(54, 162, 235, 0.2)',
          'rgba(255, 206, 86, 0.2)',
          'rgba(75, 192, 192, 0.2)',
          'rgba(153, 102, 255, 0.2)',
          'rgba(255, 159, 64, 0.2)'
        ],
        mem:['rgba(255, 99, 132, 0.2)'],

      },
        }),
        created(){
          this.time = 'hour'
          this.getG()
        },
        computed:{

          modelKeyC(){
              return this.vid+'_'+this.time+'_'+this.cf
          },
          catKey(){
            return this.charts[this.category].key || undefined
          },
          modelC(){
            return VserverGraph.find(this.modelKeyC) || undefined
          },
          labels() {
            if(this.time === 'live') return this.liveLabel
            if(this.time === 'hour') return this.modelC['time'].map((el,index)=>this.$moment(el).format('hh:mm:ss'))
            return this.modelC['time'].map((el,index)=>this.$moment(el).format('DD.MM.YY hh:mm '))
          },
          color(){
            return this.backgroundColor[this.category] || ['rgba(75, 192, 192, 0.2)']
          },
          graphmodelC(){
            if(!VserverGraph.find(this.modelKeyC)) return
            const x = Object.assign({},VserverGraph.find(this.modelKeyC))
            const n = this.$nextTick()
            const y =  {
              labels:this.labels,
              datasets : [
                  {
                    data: x[this.category],
                    backgroundColor: this.color || ['rgba(75, 192, 192, 0.2)'],
                    label:this.catKey
                  },
                ]
            }
            if(this.showCapacity) y.datasets.push({
              data:x['max'+this.category],
              type:'line',
              fill: false,
              borderColor: 'rgba(75, 192, 192, 1)',
              label:'Kapazität',
              backgroundColor:[]
            })
            //if(this.category==='mem' && this.showCapacity) y.datasets.push({data:x['maxmem']})
            //if(this.category==='cpu' && this.showCapacity) y.datasets.push({data:x['maxcpu']})
            //if(this.catKey==='cpu') y.datasets.push({data:x['maxcpu']})
            return y || undefined


          },
          vid(){
            return this.$route.params.id || undefined
          },
          optionsC(){
            return ChartOptions[this.time] || ChartOptions['live']
          },
          graphsC(){
            if(VserverGraph.all().length === 0 ) return
            return VserverGraph.all().map(el=>el.tid)
          },
        },
    methods:{
      getG(){
            //if(this.time === 'live') {this.timer = setInterval(this.getG(), 4000)}
            //if(this.time !== 'live') {clearInterval(this.timer)}
        if(this.time === 'live') {
          const t = Date.now()
          this.liveLabel.push(this.$moment(t).format('hh:mm:ss'))
        }
        VserverGraph.getGraph(this.vid, this.cf, this.time)
      }
    }
    }
</script>

<style scoped>
.mem{
  background-color: rgba(255, 99, 132, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/components/charts/chart-controller-vserver.vue